<template>
  <div class="bar-chart min-w-[700px] overflow-x-auto">
    <Bar
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
    />
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

export default {
  name: 'BarChart',
  components: { Bar },
  props: {
    label: String,
    chartData: Array,
    chartId: {
      type: String,
      default: 'bar-chart',
    },
    indexAxis: {
      type: String,
      default: 'x',
    },
    datasetIdKey: {
      type: String,
      default: 'label',
    },
    width: {
      type: Number,
      default: 600,
    },
    height: {
      type: Number,
      default: 200,
    },
    maxXVal: {
      type: Number,
      default: null,
    },
    cssClasses: {
      default: '',
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      defchartData: {
        labels: [
          'initial Comm..',
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ],
        datasets: [
          {
            label: this.label,
            data: [200, 750, 600, 500, 300, 450, 500, 200, 300, 500, 400, 500, 500],
            backgroundColor: ['#278c64'],
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: this.indexAxis,
        scales: {
          x: {
            beginAtZero: true,
            max: this.maxXVal, // adds constant padding to prevent label cutoff
          },
        },
        plugins: this.plugins,
      },
    };
  },
};
</script>

<style scoped>
.bar-chart canvas {
}
</style>
